"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimeZoneSearch = void 0;
const client_1 = require("@apollo/client");
const use_time_zone_search_graphql_1 = require("./use-time-zone-search.graphql");
const useTimeZoneSearch = () => {
    return (0, client_1.useLazyQuery)(use_time_zone_search_graphql_1.SEARCH_TIME_ZONES, { fetchPolicy: 'network-only' });
};
exports.useTimeZoneSearch = useTimeZoneSearch;
